/* eslint-disable import/no-cycle */
import Link from 'next/link';
import { MARK_LINK, render } from 'storyblok-rich-text-react-renderer';

import CallToAction from '@/components/richtext/CallToAction';
import Embed from '@/components/richtext/Embed';
import ImageFeatured from '@/components/richtext/ImageFeatured';
import ImageFloat from '@/components/richtext/ImageFloat';
import ImageRow from '@/components/richtext/ImageRow';
import LargeText from '@/components/richtext/LargeText';
import Pullquote from '@/components/richtext/Pullquote';
import StatsRow from '@/components/richtext/StatsRow';
import Video from '@/components/richtext/Video';

import SocialIcons from '../richtext/SocialIcons';

const RichtextComponent = ({ content }) => {
  return (
    <>
      {render(content, {
        markResolvers: {
          // @ts-ignore
          superscript: (children) => <sup>{children}</sup>,
          subscript: (children) => <sub>{children}</sub>,
          [MARK_LINK]: (children, props) => {
            const { linktype, href, target } = props;
            if (linktype === 'email') {
              // Email links: add `mailto:` scheme and map to <a>
              return <a href={`mailto:${href}`}>{children}</a>;
            }
            if (href.match(/^(https?:)?\/\//)) {
              // External links: map to <a>
              return (
                <a href={href} target={target}>
                  {children}
                </a>
              );
            }
            // Internal links: map to <Link>
            return (
              <Link href={href}>
                <>{children}</>
              </Link>
            );
          },
        },
        blokResolvers: {
          richtextCallToAction: (props) => (
            <CallToAction
              uid={props._uid}
              heading={props.heading}
              text={props.text}
              actions={props.actions}
              {...props}
            />
          ),
          richtextImageRow: (props) => <ImageRow blok={props} />,
          richtextImageFloat: (props) => (
            <ImageFloat
              uid={props._uid}
              image={props.image}
              image_size={props.image_size}
              float={props.float}
              {...props}
            />
          ),
          richtextImageFeatured: (props) => (
            <ImageFeatured
              uid={props._uid}
              image={props.image}
              size={props.size}
              {...props}
            />
          ),
          richtextVideo: (props) => (
            <Video
              uid={props._uid}
              video_asset={props.video_asset}
              video_url={props.video_url}
              {...props}
            />
          ),
          richtextStatsRow: (props) => (
            <StatsRow uid={props._uid} stats={props.stats} {...props} />
          ),
          richtextPullquote: (props) => (
            <Pullquote
              uid={props._uid}
              quote={props.quote}
              name={props.name}
              position={props.position}
              {...props}
            />
          ),
          richtextLargeText: (props) => <LargeText text={props.text} />,
          richtextEmbed: (props) => <Embed embed={props.embed} {...props} />,
          SocialIcons: (props) => <SocialIcons {...props} />,
        },
        defaultBlokResolver: (name, props) => (
          <div>
            <code>Missing blok resolver for blok type {name}.</code>
            <pre>
              <code>{JSON.stringify(props, undefined, 2)}</code>
            </pre>
          </div>
        ),
      })}
    </>
  );
};

export default RichtextComponent;
